import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const data = {
  summaryChartData: {},
  summaryPageMaxPercent: 0,
  summaryPageMaxDecimalBase: 0,
  summaryPageMaxDecimalComp: 0,
  summaryPageMaxDecimalOverall: 0,
};

export default {
  namespaced: true,
  state: data,
  getters,
  mutations,
  actions,
};
